import React from 'react'

const Account = () => {
  return (
    <div><h3>Account Settings</h3><p>Edit your profile info here.</p></div>
  )
}

export default Account